var INPUT = 'INPUT';
const ANCHOR = 'A';
const BUTTON = 'BUTTON';
const ALLOWED_TYPES = [
  INPUT,
  ANCHOR,
  BUTTON,
];

const LoadingStates = ({
  buttonSelector = 'input[type=submit]',
  disabledClass = 'btn--disabled',
  loadingText = 'loading',
}) => {
  var submitButton = document.querySelector(buttonSelector);
  var { nodeName } = submitButton;

  if (typeof submitButton !== 'object') {
    throw new Error('submitButton must be defined in the options');
  }

  if (ALLOWED_TYPES.indexOf(submitButton.nodeName) === -1) {
    throw new Error('submitButton must be an input, button or a tag');
  }

  var buttonTextFromInput = () => submitButton.value;
  var buttonTextFromButton = () => submitButton.textContent;
  var buttonTextFromATag = () => submitButton.text;

  var buttonText = () => {
    if (nodeName === INPUT) {
      return buttonTextFromInput();
    }

    if (nodeName === BUTTON) {
      return buttonTextFromButton();
    }

    return buttonTextFromATag();
  };

  var enableSubmitButton = () => {
    submitButton.disabled = false;
    submitButton.classList.remove(disabledClass);
  };

  var disableSubmitButton = () => {
    submitButton.disabled = true;
    submitButton.classList.add(disabledClass);
  };

  var applyText = (text) => {
    switch (nodeName) {
      case INPUT:
        submitButton.value = text;
        break;
      case BUTTON:
        submitButton.textContent = text;
        break;
      default:
        submitButton.text = text;
    }
  };

  var defaultButtonText = buttonText();

  var applyLoading = () => {
    disableSubmitButton();
    applyText(loadingText);
  };

  var removeLoading = () => {
    enableSubmitButton();
    applyText(defaultButtonText);
  };


  var API = {
    applyLoading,
    removeLoading,
  };

  return API;
};

export default LoadingStates;
